import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Creators as servicesCreators } from '../../store/ducks/services';
import { history } from '../../store';
import { Container, ServiceText, ImageService } from './styles';

function CardServiceCategory({
  idCategory,
  nameCategory,
  imageCategory,
}) {
  const dispatch = useDispatch();
  const companySource = useSelector(state => state.company.data.source || '');

  const selectAndGoToServices = () => {
    history.push(`/partner/${companySource || 'triider'}/${idCategory}`);
  };

  const getImageIcon = (categoryUrl, nameCategory) => {
    const name = nameCategory.trim().toLowerCase().replaceAll(' ', '-');
    return (
      !categoryUrl || categoryUrl == null ? `../categories/${name}.svg` : categoryUrl
    );
  };

  return (
    <Container onClick={() => selectAndGoToServices()}>
      <ImageService src={getImageIcon(imageCategory, nameCategory)} />
      <ServiceText>
        {nameCategory}
      </ServiceText>
    </Container>
  );
}

export default CardServiceCategory;
